import { CanDeactivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';

export interface HasPendingChanges {
  hasUnsavedChanges(): boolean;
  handlePendingChanges(): Observable<boolean>;
}

export const pendingChangesGuard: CanDeactivateFn<HasPendingChanges> = (
  component,
) => {
  if (component.hasUnsavedChanges()) {
    return component.handlePendingChanges();
  }
  return of(true);
};
